import React, { useMemo } from "react";
import { sanitizeHtml } from "../utils/richText";
export default function RichText({ html, as: Tag = "span", profile = "inline", ...rest }) {
  const clean = useMemo(() => sanitizeHtml(html, profile), [html, profile]);
  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: clean }} />;
}